import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FileDownloadService} from './file_download.service';

@Component({
    selector: 'app-file-download',
    template: '<button type="button" (click)="downloadFile()" class="btn btn-secondary btn-sm" [disabled]="disabled">' +
                '<span *ngIf="!downloading">{{ btnTitle }}</span>' +
                '<span *ngIf="downloading"><i class="fa fa-spinner fa-pulse" ></i></span>' +
              '</button>',
})
export class FileDownloadComponent implements OnInit{

    /**
     * Input parameters. File pk, filename and file type
     */
    @Input() filepk: number;
    @Input() filename: string;
    @Input() filetype: string;
    @Input() minio: number;
    @Input() typeResource: string;
    @Input() pkResource: number;
    @Input() btnTitle: string = 'Download';

    @Output() fileDownloaded = new EventEmitter();

    disabled: boolean = false;


    downloading: boolean;

    /**
     * @param {FileDownloadService} fileDownload
     */
    constructor(private fileDownload: FileDownloadService) {
        this.downloading = false;
        this.filetype = 'text/plain';
    }

    ngOnInit(): void {
        if( this.filename.length == 0){
            this.disabled = true;
        }
    }

    /**
     * Performs file download
     */
    downloadFile() {
        this.downloading = true;
        let observable = (this.minio)
            ? this.fileDownload.downloadMinioFile(this.typeResource, this.pkResource, this.filetype, this.filename)
            : this.fileDownload.downloadFile(this.filepk, this.filename)
        ;

        observable.subscribe(
            (r) => {
                const linkElement = document.createElement('a');

                if (r.byteLength === 0) {
                    this.fileDownload.getSubject().next('File with name ' + this.filename + ' cannot be downloaded');
                } else {
                    try {
                        const blob = new Blob([r], { type: this.filetype + '; charset=UTF-8' });
                        const url = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute('download', this.filename);

                        const clickEvent = new MouseEvent('click', {'view': window, 'bubbles': true, 'cancelable': false});
                        linkElement.dispatchEvent(clickEvent);

                    } catch (ex) {
                        console.log(ex);
                    }
                }


                this.downloading = false;
                this.fileDownloaded.emit(this.filename);
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/file_download/file_download.component.ts